import { createAsyncThunk } from '@reduxjs/toolkit';

import { customMailApi } from 'apis/custom-mail.apis';
import { GetListPayload, Option } from 'interfaces';
import { Country, CustomMailTemplate } from 'interfaces/custom-mail';

import { showServerError, successNotify } from '../../helpers';

export const CUSTOM_MAIL_SLICE_NAME = 'customMail';

export const getMailTypes = createAsyncThunk<Option[], void, { rejectValue: unknown }>(
  'customMail/getMailTypes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await customMailApi.getMailTypes();
      return response.data.data;
    } catch (err) {
      showServerError(err);
      return rejectWithValue(err);
    }
  },
);

export const getEntities = createAsyncThunk<Option[], void, { rejectValue: unknown }>(
  'customMail/getEntities',
  async (_, { rejectWithValue }) => {
    try {
      const response = await customMailApi.getEntities();
      return response.data.data;
    } catch (err) {
      showServerError(err);
      return rejectWithValue(err);
    }
  },
);

export const getCustomMailTemplate = createAsyncThunk<CustomMailTemplate, void, { rejectValue: unknown }>(
  'customMail/getCustomMailTemplate',
  async (_, { rejectWithValue }) => {
    try {
      const response = await customMailApi.getCustomMailTemplate();
      return response.data.data;
    } catch (err) {
      showServerError(err);
      return rejectWithValue(err);
    }
  },
);

export const getCustomMailEntityMembers = createAsyncThunk(
  `${CUSTOM_MAIL_SLICE_NAME}/getCustomMailEntityMembers`,
  async (params: GetListPayload & { entity: string }, { rejectWithValue }) => {
    try {
      const { entity, ...rest } = params;
      const response = await customMailApi.getCustomMailEntityMembers(entity, rest);
      return response.data;
    } catch (err) {
      showServerError(err);
      return rejectWithValue(err);
    }
  },
);

export const getCustomMailUsers = createAsyncThunk(
  `${CUSTOM_MAIL_SLICE_NAME}/getCustomMailUsers`,
  async (params: GetListPayload & { entity: string }, { rejectWithValue }) => {
    try {
      const { entity, ...rest } = params;
      const response = await customMailApi.getCustomMailUsers(entity, rest);
      return response.data;
    } catch (err) {
      showServerError(err);
      return rejectWithValue(err);
    }
  },
);

export const customMailSending = createAsyncThunk(
  `${CUSTOM_MAIL_SLICE_NAME}/customMailSending`,
  async (data: { subject: string; body: string; ids: number[]; type: string; entity: string }, { rejectWithValue }) => {
    try {
      const response = await customMailApi.customMailSending(data);
      successNotify('Email sent successfully');
      return response.data;
    } catch (err) {
      showServerError(err);
      return rejectWithValue(err);
    }
  },
);

export const getCountryList = createAsyncThunk<Country[], void, { rejectValue: unknown }>(
  'customMail/getCountryList',
  async (_, { rejectWithValue }) => {
    try {
      const response = await customMailApi.getCountryList();
      return response.data.data;
    } catch (err) {
      showServerError(err);
      return rejectWithValue(err);
    }
  },
);

export const getCustomMailSent = createAsyncThunk(
  `${CUSTOM_MAIL_SLICE_NAME}/getCustomMailSent`,
  async (params: GetListPayload, { rejectWithValue }) => {
    try {
      const { ...rest } = params;
      const response = await customMailApi.getCustomMailSent(rest);
      return response.data;
    } catch (err) {
      showServerError(err);
      return rejectWithValue(err);
    }
  },
);
